module.exports = __webpack_public_path__ + "static/img/bgg.c16a7d87.jpg";